import React from 'react'

export function TableDescription({betterOrWorse}) {
  const color = betterOrWorse === 'better' ? '#389e0d' : '#cf1322';
  return (
    <h3
      className={`table-description ${betterOrWorse}`}
      style={{ textAlign: 'left', color, fontWeight: 600, marginBottom: 8, background: 'none' }}
    >
      List of measures performing significantly <em>{betterOrWorse}</em> for the selected aggregation type
    </h3>
  )
}
